export default "__VITE_ASSET__5g3e0JMn__"